import { Box } from '@mui/material';
import { Dialog, TextField } from 'components/commons';
import ja from 'utils/ja';
interface AddTagDialogProps {
  open: boolean;
  onClose: () => void;
  handleConfirm: () => void;
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  errorMessage?: string;
}

const AddTagDialog = ({
  open,
  onClose,
  handleConfirm,
  value,
  setValue,
  errorMessage,
}: AddTagDialogProps) => {
  return (
    <Dialog
      open={open}
      handleClose={onClose}
      title={ja.tag.dialog_add.title}
      handleConfirm={handleConfirm}
    >
      <Box
        sx={{
          width: { xs: '80vw', sm: '500px' },
          padding: '10px',
          '& *': { fontSize: '18px !important' },
        }}
      >
        <TextField
          id='tagName'
          label={ja.tag.tags}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === ',' || e.key === ' ') {
              e.preventDefault();
            }
          }}
          require
          placeholder={ja.tag.content}
          error={errorMessage && { message: errorMessage }}
          // {...({ helperText: errorMessage || '' } as any)}
        />
      </Box>
    </Dialog>
  );
};
export default AddTagDialog;
